import { render, staticRenderFns } from "./StudentContentViews.vue?vue&type=template&id=0929995b&scoped=true&"
import script from "./StudentContentViews.vue?vue&type=script&lang=js&"
export * from "./StudentContentViews.vue?vue&type=script&lang=js&"
import style0 from "./StudentContentViews.vue?vue&type=style&index=0&id=0929995b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929995b",
  null
  
)

export default component.exports